import { client } from "@/api/client";
import interceptors from "@/api/interceptor";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function requestB2b(params) {
	return client.post("seller/b2b/request", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function addProductB2b(params) {
	return client.post("seller/b2b/add-product", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function updateProductB2b(params) {
	return client.post("seller/b2b/edit-product", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function uploadImage(params) {
	return client.post("seller/b2b/upload-image", params, {
		header: {
			'Content-Type': 'multipart/form-data'
		}
	});
}

function canRequestB2b() {
	return client.get("seller/b2b/store-already-request");
}

export default {
	requestB2b,
	addProductB2b,
	updateProductB2b,
	uploadImage,
	canRequestB2b
};